import { Link } from '@hover/blueprint';
import React from 'react';
import styled from 'styled-components';

import { useTranslate } from 'src/shared/hooks';

const MAIN_CONTENT_ID = 'main';

const StyledLink = styled(Link)`
  background: #fff;
  clip: rect(1px, 1px, 1px, 1px);
  left: 50%;
  overflow: hidden;
  padding: 0.5rem;
  position: fixed;
  text-align: center;
  transform: translateX(-50%);
  top: -100%;
  z-index: 9999;

  &:focus {
    clip: unset;
    margin: auto;
    overflow: visible;
    top: 0;
  }
`;

const SkipLink = () => {
  const t = useTranslate('common');

  return (
    <StyledLink href={`#${MAIN_CONTENT_ID}`}>{t('skipToContent')}</StyledLink>
  );
};

export { MAIN_CONTENT_ID, SkipLink };
